import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'labelinput',
  templateUrl: './labelinput.component.html',
  styleUrls: ['./labelinput.component.scss'],
})
export class LabelinputComponent implements OnInit {
  @Input() title: string = 'Texto';
  @Input() width: string = '300px';
  @Input() widthlabel: string = '90px';
  @Input() type: string = 'text';
  @Input() disabled: boolean = false;

  @Input() value: string = '';
  @Output() valueChange = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  get stylish() {
    return {
      width: this.width,
    };
  }

  change() {
    this.valueChange.emit(this.value);
  }

  get labelstyle() {
    return {
      width: this.widthlabel,
    };
  }
}
